// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__TbD9-","wrapper":"Terms_wrapper__IVXPC","logo":"Terms_logo__JenXy","heading":"Terms_heading__jgj0x"};